import * as React from 'react';
import GridContainer from "../../GenericComponents/Grids/GridContainer";
import {toast} from "react-toastify";
import * as actionTypes from "../../../store/action";
import {connect} from "react-redux";
import {createBreadCrumbBasedOnPage} from "../../../Utils/HelperFunctions";
import {Button, ButtonProps, Container, Dimmer, Header, Icon, Loader, Segment} from "semantic-ui-react";
import history from "../../../history";
import {Redirect} from "react-router";
import UpgradeApi from "../../../services/upgrade-service";
import UpgradeFormSection from "./UpgradeFormSection";

interface ReliabilityUpgradeFormProps {
    setBreadCrumbPath: (breadCrumbPath:BreadCrumb[]) => void;
    location: any;
    setLoggedIn: (loggedIn:boolean) => void;
    loggedIn: boolean;
    backToMainUpgradeForm: (savedTopLevelForm:boolean) => void;
    topLevelUpgradeFormObject: InitialUpgradeCreateResponse;
    topLevelFormMetaData ?: any;
}

interface ReliabilityUpgradeFormState {
    pageLoading: boolean
    userAuthorized: boolean
    reliabilityFormObject: ReliabilityForm;
    formMetaData: any
    submitClicked: boolean
    canSubmit: boolean
    requiredArray: Map<string, boolean>
}

class ReliabilityUpgradeForm extends React.Component<ReliabilityUpgradeFormProps,ReliabilityUpgradeFormState> {
    private upgradeClient: UpgradeApi;

    constructor(props: ReliabilityUpgradeFormProps) {
        super(props);
        this.state = {
            pageLoading: true,
            userAuthorized: false,
            submitClicked: false,
            canSubmit: false,
            requiredArray: new Map(),
            reliabilityFormObject: {
                reliabilityExpansionDetailsRequest: {
                    networkUpgradeType: '',
                    fundingType: '',
                    scertViewType: '',
                    upgradeCategoryType: '',
                    facilityOwnerCod: '',
                    upgradeSubcategory: '',
                    newFacilityOwner: '',
                    basePlanType: '',
                    stepDate: null,
                    stepStatus: '',
                    upgradeLeadTime: 0,
                    idevFileName: '',
                    upgradeSpecificationDescription: '',
                    basePlanReasonDescription: '',
                    authorizationToPlanDescription: '',
                    upgradeBoardActionDescription: '',
                    upgradeJustificationComment: '',
                    ntcSentComment: ''
                },
                upgradeBusRequest: {
                    fromBusNumber: '',
                    fromBusTempInd: false,
                    toBusNumber: '',
                    toBus1TempInd: false,
                    tertiaryBusNumber: '',
                    toBus2TempInd: false,
                    circuitCode: '',
                    designKvRate: 0,
                    highVoltageKvRate: 0,
                    lowVoltageKvRate: 0,
                    newMilesCount: 0,
                    operatingKvRate: 0,
                    reconductorMiles: 0,
                    summerEmergencyRatingMvaRate: 0,
                    summerNormalRatingMvaRate: 0,
                    tertiaryVoltageKvRate: 0,
                    voltageConversionMiles: 0,
                    winterEmergencyRatingMvaRate: 0,
                    winterNormalRatingMvaRate: 0,
                    totalRatingDescription: ''
                },
                upgradeCostInfoRequest: {
                    upgradeCostEstimateDate: null,
                    upgradeEstimatedCostAmount: 0,
                    upgradeEstimatedCostSourceDescription: '',
                    upgradeFinalCostAmount: 0,
                    sourceOfFinalCost: '',
                    finalCostReceivedDate: null,
                    requestForFinalCostSentDate: null,
                    originalEstimatedCost: 0,
                    sppEstimatedCost: 0
                },
                upgradeModInfoRequest: {
                    modProjectPhaseId: 0,
                    submittedOrModifiedDate: null,
                    modProjectId: 0,
                    originalModProjectId: 0,
                    modEffectiveDate: null,
                    modeledInType: '',
                    sppProjectPhaseComment: ''
                }
            },
            formMetaData: null
        };

        this.upgradeClient = new UpgradeApi();
    }

    componentDidMount(): void {
        this.props.setBreadCrumbPath(createBreadCrumbBasedOnPage(window.location.pathname.split('/').filter(x => x)));

        this.getReliabilityUpgradeFormDetails();
        let { requiredArray } = this.state;
        requiredArray.set('reliabilityForm', false);
        requiredArray.set('upgradeBusForm', false);
        requiredArray.set('upgradeCostInfoForm', false);
        requiredArray.set('upgradeModInfoForm', false);
        this.setState({requiredArray});
    }

    componentDidUpdate(prevProps: Readonly<ReliabilityUpgradeFormProps>, prevState: Readonly<ReliabilityUpgradeFormState>) {
        if(this.state.canSubmit && this.state.submitClicked) {
            let readyToSubmit = true;
            this.state.requiredArray.forEach(function(value, key) {
                if(value === false) {
                    readyToSubmit = false;
                }
            });
            if(readyToSubmit) {
                let upgradeCreateRequest: CreateUpgradeRequest = {
                    initialUpgradeCreateResponse: this.props.location.state.topLevelUpgradeFormObject,
                    generationInterconnectionRequest: null,
                    reliabilityExpansionRequest: this.state.reliabilityFormObject,
                    transmissionServiceRequest: null
                }

                this.upgradeClient.submitUpgradeRequest(upgradeCreateRequest)
                    .then((response:any) => {
                        if(response === 'Success') {
                            toast.success('Successfully created Reliability upgrade');
                            const currentPath = this.props.location.pathname;
                            history.push({
                                pathname: '/upgrades',
                                state: {from: currentPath}
                            });
                        }
                        else {
                            toast.warn('Issue creating upgrade.  Please contact IT.');
                        }
                    })
                this.setState({canSubmit: false});
            }
            else {
                this.setState({submitClicked: false});
            }
        }
    }

    getReliabilityUpgradeFormDetails = () => {
        this.upgradeClient.getReliabilityUpgradeCreateForm()
            .then((response: any) => {
                this.setState({
                    reliabilityFormObject: response.data[0],
                    formMetaData: response.columnMetaDataList,
                    userAuthorized: true,
                    pageLoading: false
                });
            })
            .catch((error: any) => {
                if (error.response.status === 403) {
                    this.setState({userAuthorized: false, pageLoading: false});
                }
                if (!error.response.data.badToken) {
                    toast.error(`Error retrieving data from the server - ${error.response.data.message}`)
                } else {
                    this.props.setLoggedIn(false);
                }
            });
    };

    backToMainForm = (event: React.MouseEvent<HTMLButtonElement>, data:ButtonProps) => {
        const currentPath = this.props.location.pathname;
        history.push({
            //pathname: this.props.location.state !== undefined ? this.props.location.state.from : '/upgrades/createUpgrade/',
            pathname: '/upgrades/createUpgrade',
            state: {from: currentPath, topLevelUpgradeFormObject: this.props.location.state.topLevelUpgradeFormObject, topLevelFormMetaData: this.props.location.state.topLevelFormMetaData}
        });
        //this.props.backToMainUpgradeForm(false);
    };

    saveWebForm = () => {
        /*let upgradeCreateRequest: CreateUpgradeRequest = {
            initialUpgradeCreateResponse: this.props.topLevelUpgradeFormObject,
            generationInterconnectionRequest: null,
            reliabilityExpansionRequest: this.state.reliabilityFormObject,
            transmissionServiceRequest: null
        }

        this.upgradeClient.submitUpgradeRequest(upgradeCreateRequest)
            .then((response:any) => {
                toast.success('Successfully created upgrade');
            })*/

        let { requiredArray } = this.state;
        requiredArray.set('reliabilityForm', false);
        requiredArray.set('upgradeBusForm', false);
        requiredArray.set('upgradeCostInfoForm', false);
        requiredArray.set('upgradeModInfoForm', false);
        this.setState({submitClicked:true, requiredArray, canSubmit: true});
    };

    resetWebForm = () => {
        let { reliabilityFormObject } = this.state;
        reliabilityFormObject = {
            reliabilityExpansionDetailsRequest: {
                networkUpgradeType: '',
                fundingType: '',
                scertViewType: '',
                upgradeCategoryType: '',
                facilityOwnerCod: '',
                upgradeSubcategory: '',
                newFacilityOwner: '',
                basePlanType: '',
                stepDate: null,
                stepStatus: '',
                upgradeLeadTime: 0,
                idevFileName: '',
                upgradeSpecificationDescription: '',
                basePlanReasonDescription: '',
                authorizationToPlanDescription: '',
                upgradeBoardActionDescription: '',
                upgradeJustificationComment: '',
                ntcSentComment: ''
            },
            upgradeBusRequest: {
                fromBusNumber: '',
                fromBusTempInd: false,
                toBusNumber: '',
                toBus1TempInd: false,
                tertiaryBusNumber: '',
                toBus2TempInd: false,
                circuitCode: '',
                designKvRate: 0,
                highVoltageKvRate: 0,
                lowVoltageKvRate: 0,
                newMilesCount: 0,
                operatingKvRate: 0,
                reconductorMiles: 0,
                summerEmergencyRatingMvaRate: 0,
                summerNormalRatingMvaRate: 0,
                tertiaryVoltageKvRate: 0,
                voltageConversionMiles: 0,
                winterEmergencyRatingMvaRate: 0,
                winterNormalRatingMvaRate: 0,
                totalRatingDescription: ''
            },
            upgradeCostInfoRequest: {
                upgradeCostEstimateDate: null,
                upgradeEstimatedCostAmount: 0,
                upgradeEstimatedCostSourceDescription: '',
                upgradeFinalCostAmount: 0,
                sourceOfFinalCost: '',
                finalCostReceivedDate: null,
                requestForFinalCostSentDate: null,
                originalEstimatedCost: 0,
                sppEstimatedCost: 0
            },
            upgradeModInfoRequest: {
                modProjectPhaseId: 0,
                submittedOrModifiedDate: null,
                modProjectId: 0,
                originalModProjectId: 0,
                modEffectiveDate: null,
                modeledInType: '',
                sppProjectPhaseComment: ''
            }
        };

        this.setState({reliabilityFormObject});
        toast.info('Cleared All Reliability Form Fields');
    };

    updateAccordionContent = (sectionContent:any, sectionName:string) => {
        let { reliabilityFormObject } = this.state;
        switch(sectionName) {
            case 'reliabilityForm':
                reliabilityFormObject.reliabilityExpansionDetailsRequest = sectionContent;
                break;
            case 'upgradeBusForm':
                reliabilityFormObject.upgradeBusRequest = sectionContent;
                break;
            case 'upgradeCostInfoForm':
                reliabilityFormObject.upgradeCostInfoRequest = sectionContent;
                break;
            case 'upgradeModInfoForm':
                reliabilityFormObject.upgradeModInfoRequest = sectionContent;
                break;
        }

        this.setState({reliabilityFormObject});
    };

    setRequiredFieldsInSectionFilledIn = (missingRequired:boolean, sectionName:string) => {
        let { requiredArray } = this.state;
        if(missingRequired) {
            requiredArray.set(sectionName, false);
        }
        else {
            requiredArray.set(sectionName, true);
        }
        this.setState({requiredArray});
    };

    /*setRequiredFieldsInSectionFilledIn = (missingRequired:boolean) => {
        if(missingRequired) {
            this.setState({submitClicked:false, numberOfSectionsChecked: 0});
        }
        else {
            if(this.state.numberOfSectionsChecked === 4) {
                let upgradeCreateRequest: CreateUpgradeRequest = {
                    initialUpgradeCreateResponse: this.props.topLevelUpgradeFormObject,
                    generationInterconnectionRequest: null,
                    reliabilityExpansionRequest: this.state.reliabilityFormObject,
                    transmissionServiceRequest: null
                }

                this.upgradeClient.submitUpgradeRequest(upgradeCreateRequest)
                    .then((response: any) => {
                        toast.success('Successfully created upgrade');
                    })

                this.setState({submitClicked:false, numberOfSectionsChecked: 0});
            }
            else {
                let sectionsChecked = this.state.numberOfSectionsChecked;
                sectionsChecked += 1;
                this.setState({numberOfSectionsChecked: sectionsChecked});
            }
        }
    };*/

    render() {
        if(this.props.location.state === undefined || this.props.location.state.topLevelUpgradeFormObject === undefined || this.props.location.state.topLevelUpgradeFormObject.upgradeType === '') {
            return (
                <Redirect to={'/upgrades/createUpgrade'} />
            )
        }

        return (
            <Container fluid={true}>
                <Button icon={true} labelPosition='left' onClick={this.backToMainForm}>
                    <Icon name={'arrow left'} />
                    Back to Main Upgrade Form
                </Button>
                <Segment basic={true}>
                    {this.props.loggedIn && this.state.userAuthorized &&
                        <React.Fragment>
                            <Header as='h2' block={true}>
                                Add New Reliability/Economic Upgrade
                            </Header>
                            <UpgradeFormSection
                                location={this.props.location}
                                sectionMetaDataEndpoint={'/getReliabilityUpgradeFormMetaData'}
                                sectionName={'reliabilityForm'}
                                segmentHeader={'Reliability Expansion Upgrade Form'}
                                accordionContent={this.state.reliabilityFormObject.reliabilityExpansionDetailsRequest}
                                formMetaData={this.state.formMetaData}
                                resetWebForm={this.resetWebForm}
                                updateAccordionContent={this.updateAccordionContent}
                                submissionClicked={this.state.submitClicked}
                                setRequiredFieldsMissingInForm={this.setRequiredFieldsInSectionFilledIn}
                            />
                            <UpgradeFormSection
                                location={this.props.location}
                                sectionMetaDataEndpoint={'/getUpgradeBusMetaData'}
                                sectionName={'upgradeBusForm'}
                                segmentHeader={'Reliability Expansion Upgrade Bus Info'}
                                accordionContent={this.state.reliabilityFormObject.upgradeBusRequest}
                                formMetaData={this.state.formMetaData}
                                resetWebForm={this.resetWebForm}
                                updateAccordionContent={this.updateAccordionContent}
                                submissionClicked={this.state.submitClicked}
                                setRequiredFieldsMissingInForm={this.setRequiredFieldsInSectionFilledIn}
                            />
                            <UpgradeFormSection
                                location={this.props.location}
                                sectionMetaDataEndpoint={'/getUpgradeCostInfoMetaData'}
                                sectionName={'upgradeCostInfoForm'}
                                segmentHeader={'Reliability Expansion Upgrade Cost Info'}
                                accordionContent={this.state.reliabilityFormObject.upgradeCostInfoRequest}
                                formMetaData={this.state.formMetaData}
                                resetWebForm={this.resetWebForm}
                                updateAccordionContent={this.updateAccordionContent}
                                submissionClicked={this.state.submitClicked}
                                setRequiredFieldsMissingInForm={this.setRequiredFieldsInSectionFilledIn}
                            />
                            <UpgradeFormSection
                                location={this.props.location}
                                sectionMetaDataEndpoint={'/getUpgradeModInfoMetaData'}
                                sectionName={'upgradeModInfoForm'}
                                segmentHeader={'Reliability Expansion Upgrade MOD Info'}
                                accordionContent={this.state.reliabilityFormObject.upgradeModInfoRequest}
                                formMetaData={this.state.formMetaData}
                                resetWebForm={this.resetWebForm}
                                updateAccordionContent={this.updateAccordionContent}
                                submissionClicked={this.state.submitClicked}
                                setRequiredFieldsMissingInForm={this.setRequiredFieldsInSectionFilledIn}
                            />
                            <div className={'tracWebFormButtonDiv'}>
                                <Button content={'Submit'} primary={true} onClick={this.saveWebForm}/>
                                <Button content={'Reset'} negative={true} onClick={this.resetWebForm}/>
                            </div>
                        </React.Fragment>
                    }
                    <Dimmer className={'pageLoader'} active={this.state.pageLoading} inverted={true}>
                        <Loader size='large'>Loading</Loader>
                    </Dimmer>
                </Segment>
            </Container>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        loggedIn: state.defaultReducer.loggedIn
    }
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        setLoggedIn: (loggedIn: boolean) => dispatch(
            {type: actionTypes.LOGGED_IN, payload: loggedIn}),
        setBreadCrumbPath: (breadCrumbPath:BreadCrumb[]) => dispatch(
            {type: actionTypes.SET_BREADCRUMB_PATH, payload: breadCrumbPath})
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ReliabilityUpgradeForm);